import { Form, notification } from 'antd'
import { useRecoilState } from 'recoil'
import Const from '../../constants'
import { cardAtom } from '../../store/card'
import { convertData } from '../../utils'
import { payment } from '../apiRepo'
import { useGMOMultiPayment } from './useGMOMultiPayment'

export type GMOMultiPaymentInput = {
  cardno: number
  expireMonth: number
  expireYear: number
  holdername: string
  securitycode: number
}

export const useCreatePaymentMethod = () => {
  const [form] = Form.useForm()
  const { getToken } = useGMOMultiPayment()
  const [card] = useRecoilState(cardAtom)

  const onCreatePaymentMethod = async (setIsLoading: any) => {
    try {
      const dataForm = form.getFieldsValue()
      const callbackURL = `${process.env.REACT_APP_FE_URL}/callback`
      const pointData = localStorage.getItem('point')
      const { cardNumber, cardExpireAt } = convertData(dataForm)

      const data = await getToken({
        cardno: cardNumber, // card number without spaces
        expire: cardExpireAt // expiry in format 'YYYYMM'
      })

      if (data.resultCode === '000' && pointData) {
        let dataSubmit = {
          card_token: data.tokenObject.token,
          card_state: 0,
          callbackURL,
          point: parseInt(pointData)
        }

        if (card) {
          dataSubmit = {
            ...dataSubmit,
            card_state: 1
          }
        }
        const res = await payment(dataSubmit)
        window.location.href = res.data.data.redirectURL
      } else if (data.resultCode in Const.TOKEN_ERROR) {
        notification.error({
          message: `エラー発生しました [${data.resultCode}]`,
          description:
            Const.TOKEN_ERROR[data.resultCode as keyof typeof Const.TOKEN_ERROR]
        })
      }
    } catch (e: any) {
      if (e?.response?.data?.error?.message) {
        notification.error({
          message: `エラー発生しました`,
          description: e.response.data.error.message
        })
      }
    } finally {
      setIsLoading(false)
    }
  }

  return {
    form,
    onCreatePaymentMethod
  }
}

type useCreatePaymentMethodType = typeof useCreatePaymentMethod
export type useCreatePaymentMethodResult =
  ReturnType<useCreatePaymentMethodType>
